(function(){
    // --------------------------------
    // Custom “REMOVE” button
    // --------------------------------
    function bindRemoveButton(btn) {
        // avoid double binding
        if (btn.dataset.removeBound) return;
        btn.dataset.removeBound = 'true';

        btn.addEventListener('click', function(evt) {
            evt.preventDefault();
            // get cart item quantity wrapper
            let quantityWrapper = this.previousElementSibling;
            while (quantityWrapper && !quantityWrapper.classList.contains('js-qty__wrapper')) {
                quantityWrapper = quantityWrapper.previousElementSibling;
            }
            if (!quantityWrapper) return;

            const quantityInput = quantityWrapper.querySelector('input.js-qty__num');
            if (!quantityInput) return;

            quantityInput.value = 1;
            const minusBtn = quantityWrapper.querySelector('.js-qty__adjust--minus');
            if (minusBtn) {
                // remove item from cart
                minusBtn.click();
            }
        });
    }

    function scanAndBind(root = document) {
        root.querySelectorAll('cart-remove-button').forEach(bindRemoveButton);
    }

    document.addEventListener('DOMContentLoaded', () => scanAndBind());

    const observer = new MutationObserver(mutations => {
        for (const m of mutations) {
            for (const node of m.addedNodes) {
                if (!(node instanceof Element)) continue;
                // the node is a cart-remove-button
                if (node.matches('cart-remove-button')) {
                    bindRemoveButton(node);
                }
                // the node contains new cart-remove-buttons
                else if (node.querySelector) {
                    scanAndBind(node);
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();
